import { Component} from '@angular/core';
import { AuthService } from '../modules/shared/services/auth-service/auth.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.sass'],
})
export class AppComponent {
  title = 'Expense-App';
  constructor(private readonly authService: AuthService) {}

  ngOnInit(): void {
    this.authService.handleRedirect();
    this.authService.updateUserName();
  }
}
